<template>
    <div class="">
        <icon name="briefcase" scale="2"/>
        <icon name="plus" scale="1"/>
        <router-link tag="a" :to="enedisCaseRoute">
            Ajouter une affaire
        </router-link>
    </div>
</template>

<script>
export default {
  name: 'AddEditEnedisCaseButton',
  data() {
    return {
      enedisCaseRoute: '/enediscase',
    };
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/button/AddEditEnedisCaseButton.vue